import { render, staticRenderFns } from "./dropping_form.vue?vue&type=template&id=0c7525ac&"
import script from "./dropping_form.vue?vue&type=script&lang=js&"
export * from "./dropping_form.vue?vue&type=script&lang=js&"
import style0 from "./dropping_form.vue?vue&type=style&index=0&id=0c7525ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports